import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "input-group" }
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = { class: "agreement" }
const _hoisted_5 = { class: "verification-login" }

import { ref } from 'vue'
import { showToast } from 'vant'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const router = useRouter()
const store = useStore()

// 定义表单数据
const phoneAreaPrefix = ref('86')
const phoneNumber = ref('')
const password = ref('')
const agreed = ref(false)
const showPassword = ref(false)
const showAreaCodePicker = ref(false)

// 区号数据
const areaCodeColumns = [
  { text: '中国 +86', value: '86' },
  { text: '中国香港 +852', value: '852' },
  { text: '中国澳门 +853', value: '853' },
  { text: '中国台湾 +886', value: '886' },
  { text: '日本 +81', value: '81' },
  { text: '韩国 +82', value: '82' },
  { text: '美国 +1', value: '1' },
]

// 表单校验规则
const validatePhoneNumber = () => {
  if (!phoneNumber.value) {
    showToast('请输入手机号')
    return false
  }
  if (!/^1[3-9]\d{9}$/.test(phoneNumber.value)) {
    showToast('请输入正确的手机号')
    return false
  }
  return true
}

const validatePassword = () => {
  if (!password.value) {
    showToast('请输入密码')
    return false
  }
  if (password.value.length < 6) {
    showToast('密码不能少于6位')
    return false
  }
  return true
}

const validateAgreement = () => {
  if (!agreed.value) {
    showToast('请先同意隐私政策')
    return false
  }
  return true
}

// 提交表单
const submitForm = () => {
  if (!validatePhoneNumber()) return
  if (!validatePassword()) return
  if (!validateAgreement()) return

  const data = {
    captcha: '',
    phoneAreaPrefix: phoneAreaPrefix.value,
    phoneNumber: phoneNumber.value,
    password: password.value,
    type: 0
  }
  store.dispatch('user/login', data)
}

// 忘记密码
const forgetPassword = () => {
  router.push('/ResetPwd')
}

// 注册
const register = () => {
  router.push('/Register')
}

const togglePasswordVisibility = () => {
  showPassword.value = !showPassword.value
}

const goToVerificationLogin = () => {
  router.push('/LoginCode')
}

// 区号选择确认处理函数
const onAreaCodeConfirm = (item: any) => {
  phoneAreaPrefix.value = item.selectedValues[0]
  showAreaCodePicker.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "title" }, "登录", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_field, {
        modelValue: phoneNumber.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((phoneNumber).value = $event)),
        placeholder: "输入手机号",
        border: false
      }, {
        label: _withCtx(() => [
          _createElementVNode("div", {
            class: "country-code",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showAreaCodePicker.value = true))
          }, [
            _createVNode(_component_SvgIcon, { name: "phone" }),
            _createElementVNode("span", null, "+" + _toDisplayString(phoneAreaPrefix.value), 1),
            _createVNode(_component_van_icon, {
              name: "arrow-down",
              size: "14",
              color: "#666666"
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_van_popup, {
      show: showAreaCodePicker.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((showAreaCodePicker).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          columns: areaCodeColumns,
          onConfirm: onAreaCodeConfirm,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (showAreaCodePicker.value = false)),
          title: '选择区号',
          "show-toolbar": ""
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_field, {
        modelValue: password.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((password).value = $event)),
        type: showPassword.value ? 'text' : 'password',
        placeholder: "输入密码",
        border: false
      }, {
        label: _withCtx(() => [
          _createVNode(_component_SvgIcon, { name: "pwd" })
        ]),
        "right-icon": _withCtx(() => [
          _createVNode(_component_van_icon, {
            name: showPassword.value ? 'eye-o' : 'closed-eye',
            onClick: togglePasswordVisibility
          }, null, 8, ["name"])
        ]),
        _: 1
      }, 8, ["modelValue", "type"])
    ]),
    _createElementVNode("div", { class: "action-links" }, [
      _createElementVNode("span", { onClick: forgetPassword }, "忘记密码"),
      _createElementVNode("span", { onClick: register }, "注册")
    ]),
    _createVNode(_component_van_button, {
      type: "primary",
      block: "",
      round: "",
      onClick: submitForm
    }, {
      default: _withCtx(() => _cache[6] || (_cache[6] = [
        _createTextVNode("登录")
      ])),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_van_checkbox, {
        modelValue: agreed.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((agreed).value = $event)),
        shape: "round",
        "icon-size": "12"
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode(" 登录即表示同意"),
          _createElementVNode("a", {
            href: "https://www.jingchat.cn/userProtocol.html",
            target: "_blank"
          }, "《服务条款》", -1),
          _createTextVNode("和"),
          _createElementVNode("a", {
            href: "https://www.hnmengyuqianfang.cn/features.html",
            target: "_blank "
          }, "《隐私协议》", -1)
        ])),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "verification-login-item",
        onClick: goToVerificationLogin
      }, [
        _createVNode(_component_van_icon, {
          name: "chat-o",
          color: "#FF6B00",
          size: "28"
        }),
        _cache[8] || (_cache[8] = _createElementVNode("span", null, "验证码登录", -1))
      ])
    ])
  ]))
}
}

})